import { FC } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Button, Svg, Typography } from '@altermaind/web/ui';

type Props = {
  type: 'success' | 'error';
  callback: () => void;
};

export const ThankYouMessage: FC<Props> = ({ type, callback }) => {
  // eslint-disable-next-line @altermaind/use-translations-scope
  const t = useTranslations(`thankYouMessage.${type}`);
  return (
    <Box mt='s' mb='s' textAlign='center'>
      <Box
        style={{ margin: '0 auto' }}
        display='flex'
        width='25px'
        backgroundColor={type}
        ml='xxxs'
        mt='xxxs'
        borderRadius='xl'
        p='xs'
      >
        <Svg name='close' size='s' />
      </Box>
      <Typography mt='s' variant='h1'>
        {t('title')}
      </Typography>
      <Typography variant='p2/light' mt='s'>
        {t('text')}
      </Typography>
      <Button onClick={callback} style={{ margin: '0 auto' }} mt='l' variant='primary'>
        {t('cta')}
      </Button>
    </Box>
  );
};
